import React from 'react'
import PropTypes from 'prop-types'

import { Audio } from '../index'
import { useIpbxApi } from '~/core/utils/hooks'
import { useI18n } from '~/core/i18n'

const AudioRecord = ({ url, ...props }) => {
  const [msg] = useI18n()
  const [{ error, data: audioSrc }] = useIpbxApi({
    url,
    responseType: 'blob',
    name: 'RECORDINGS',
    transformData: data => {
      const blob = new window.Blob([data], { type: 'application/octet-stream' })
      return window.URL.createObjectURL(blob)
    }
  })

  return <Audio src={audioSrc} title={error && msg('common.audioRecord.error')} {...props} />
}

AudioRecord.propTypes = {
  url: PropTypes.string.isRequired
}

export default AudioRecord
